import Dialog from "@/components/react/Dialog";
import { css } from "@styled-system/css";
import { Box, Flex } from "@styled-system/jsx";
import BibiBig from "@/assets/barkio/sep-anxiety/BibiBig.jpg";
import RockyBig from "@/assets/barkio/sep-anxiety/RockyBig.jpg";

export function Dialog1({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} closeButton variant={{ sa: "infoBox" }}>
      <Box pos="relative" maxH="90vh" px="2rem" overflow="scroll">
        <img
          alt="dog"
          src={BibiBig.src}
          className={css({
            borderTopLeftRadius: "1.5rem",
            borderTopRightRadius: "1.5rem",
            position: "absolute",
            left: "0",
            top: "0",
            right: "0",
            zIndex: 0
          })}
        />
        <Box
          className={css({
            zIndex: 0,
            position: "relative",
            "& .bold": {
              color: "highEmphasis",
              fontWeight: 700
            },
            "& p": {
              mb: "16px"
            }
          })}
        >
          <Flex h={["200px", "320px"]} flexDir="column" justifyContent="center">
            <h2 className={css({ textAlign: "center", color: "white", mb: "16px" })}>
              Bibi ate her own feces <br /> while alone
            </h2>
            <p className={css({ textAlign: "center", color: "rgba(255, 255, 255, 0.6)" })}>MVDr. Hana Zertova</p>
          </Flex>

          <p className={css({ mt: "24px" })}>
            <span className="bold">Breed:</span> French bulldog
          </p>
          <p>
            <span className="bold">Age:</span> 7 months
          </p>
          <p>
            <span className="bold">Symptoms:</span> Defecating, eating own feces
          </p>

          <p>
            Bibi was a seven-month-old female French Bulldog. She lived in a city apartment with her retired owners who
            were with her most of the time. Bibi was very nifty and obedient. She learned many tricks and got on well
            with the owners’ grandchildren, but she had a problem. As soon as she was home alone, even if for only ten
            minutes, she would immediately urinate and defecate and then she would eat those feces. She was never left
            alone for more than two hours.
          </p>

          <p>
            She was always taken outside, and it was always before the owner’s departure. As soon as she spotted someone
            was getting dressed and was ready to leave, she would run around the apartment and always get in her owners’
            way and she always gasped heavily. It was difficult to let her behind the door and leave.
          </p>
          <p>
            Unortunately, she never howled, barked or destroyed anything. Puddles of urine and half-eaten feces proved
            that loneliness scares her. She went through a veterinary examination first to rule out possible medical
            causes. Healthwise she was completely fine.
          </p>

          <p>
            There are many reasons dogs eat their own feces. Since it occurs more in female dogs than males, it is
            presumed that it is an instinctive behavior of mother dogs to keep the den clean so it does not attract
            predators. It can also occur if the puppy is raised in an environment that lacks toys and other interesting
            incentives. It can also be a sign of boredom and eagerness to play. Dogs sometimes eat feces out of fear of
            punishment. It can also mean they are hungry or lack certain nutrients. In this case, it was most likely a
            “skipping behavior” because of strong emotions, fear, and anxiety. The owners realized that whenever Bibi is
            upset (positively or negatively) she takes anything she finds in her mouth - toys, slippers, rags, socks,
            bowls and runs around the apartment.
          </p>

          <p>
            The healing process was mostly based on desensitization and counterconditioning. It was necessary to teach
            Bibi that preparation for departure does not mean any threat but a foretaste of pleasant moments with
            filling toys that the dog only tries during training and short periods of solitude later on. Because Bibi,
            like all bulldogs, was still in good shape, there was no sign of the problem after a few weeks of training.
            Whenever the owners started to dress up or were preparing to leave, Bibi would sit in front of the kitchen
            counter ready for a filling toy. She seemed to send the owners away with her look. They were able to go
            shopping or go to the theatre or to the doctors without the fear of what to come back to when they return.
            There was only Bibi welcoming them vigorously by trying to take all the amazing toys on her snout at once.
          </p>
        </Box>
      </Box>
    </Dialog>
  );
}

export function Dialog2({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} closeButton variant={{ sa: "infoBox" }}>
      <Box pos="relative" maxH="90vh" px="2rem" overflow="scroll">
        <img
          src={RockyBig.src}
          alt="dog"
          className={css({
            borderTopLeftRadius: "1.5rem",
            borderTopRightRadius: "1.5rem",
            position: "absolute",
            left: "0",
            top: "0",
            right: "0",
            zIndex: 0
          })}
        />
        <Box
          className={css({
            zIndex: 0,
            position: "relative",
            "& .bold": {
              color: "highEmphasis",
              fontWeight: 700
            },
            "& p": {
              mb: "16px"
            }
          })}
        >
          <Flex h={["200px", "320px"]} flexDir="column" justifyContent="center">
            <h3 className={css({ textAlign: "center", color: "white", mb: "16px" })}>
              Rocky whined and howled <br /> while alone
            </h3>
            <p className={css({ textAlign: "center", color: "rgba(255, 255, 255, 0.6)" })}>MVDr. Hana Zertova</p>
          </Flex>
          <p className={css({ mt: "24px" })}>
            <span className="bold">Breed:</span> Jack Russell Terrier
          </p>
          <p>
            <span className="bold">Age:</span> 15 months
          </p>
          <p>
            <span className="bold">Symptoms:</span> whining, howling, inappetence
          </p>

          <p>
            Rocky was a fifteen-month-old active and chipper dog. Every terrier likes to bark a lot though. He was taken
            home by his new owner Monica when he was nine weeks old. She would take him to puppy school and to trainings
            on regular basis. Rocky liked to fetch a ball, so Monica started to train flyball with him. Plans were
            forced to change by Monica’s injury. She fell down skiing and badly broke her leg. She had to stay home for
            almost two months. During that time she and Rocky got very close, they spent all the time together at home,
            played and rested together. Rocky was only taken out to walk by Monica’s boyfriend or her mother.
          </p>

          <p>
            When Monica got healthy, she returned to work and Rocky stayed home alone. He had never had a problem with
            solitude - Monica was getting him used to solitude from the very first days and Rocky was calm and happy. He
            slept through most of the days, he only started to bark when he heard sound from the corridor. Now he
            started to whine immediately after Monica left.ú Food, water or the toys were untouched but immediately
            after he welcomed Monica he rushed towards the bowls and made up for it. After the walk he was exhausted and
            fell asleep at Monica’s feet. He was constantly controlling whether she was leaving. Whenever she got up, he
            watched her vigilantly. The other day, he was nervous from the first moment he woke up. He would not go away
            from Monica, his tail was between his legs and he shivered. Monica turned on her video camera to see Rocky’s
            behavior after her departure. As soon as she left, Rocky started to whine by the door. After a while he lied
            down on the couch, but he kept looking at the door and he whimpered.
          </p>

          <p>
            First it was necessary that Rocky was not left all by himself. In the morning, he would go to work with
            Monica. In the afternoon and evening, he was taken care of by her mother. The second task was to calm Rocky
            down in general so he was not as impulsive. That was not easy given his natural temper. They tried to adjust
            his nutriment by reducing fat and proteins and adding food containing tryptophan (amino acid that creates
            serotonin aka happiness hormone) and vitamin B which has positive influence on nervous system.
          </p>

          <p>
            We replaced flyebal - a highly adrenaline sport with activities focused on calm concentration, especially
            olfactory (seeking owner’s objects, tracking). Monica was surprised by Rocky’s enthusiasm and skill. Another
            important thing to practice was relaxing and calming down. Monica was used to encourage Rocky and cheer for
            him. Now she had to use a different type of body language, intonation, voice and facial expressions so that
            Rocky would learn to work with concentration and learn to relax.
          </p>

          <p>
            I recommended a couple of adjustments in the apartment as well: Rocky was annoyed and upset by sounds he
            heard from the the corridor, so it was necessary to soundproof the main door and prevent him from going to
            the entrance hall in the apartment even at the times someone was at home with him. Rocky had his crate in
            Monica’s office so he would not bother colleagues. He looked satisfied there. He got new filling toys as
            well - rubber Kong and plastic balls with holes in them. When he learnt to play with them, he only got them
            for brief moments, so they remained rare to him and he fully focused on emptying them.
          </p>

          <p>
            Only then we could start the methods used for eliminating fear of solitude - desensitization connected to
            counter conditioning. During desensitization the dog is being exposed to the fear stimulus only to the
            extent that does not initiate the fear itself. Counter conditioning means continuous creating a new
            conditioned reflex to the original fear impulse - owner’s departure. Monica practiced with Rocky both at
            work and at home in the evenings and at the weekends. When Rocky lied down in his place after a walk, he got
            a filled Kong and Monica closed the crate. She got up and sat down again. She got up and made a couple steps
            towards the door and immediately returned and opened the crate. Then she grabbed her bag, took out the keys,
            walked towards the door again and returned. She would not speak to Rocky and did not pay attention to him at
            all. She only watched inconspicuously to see whether her behavior triggered any fear in him.
          </p>
          <p>
            Rocky was continuously getting most of his feeding doses in the filling toys complemented by dried cloak or
            lungs or parts of vegetable. As soon as he began to remain calm during Monica’s departure rituals, could she
            actually leave the apartment. First only for a second and then slowly for longer and longer periods. Rocky’s
            crate was sometimes open, sometimes closed. Monica kept switching between short and long absences. She left
            the filled Kong and the ball, on some other occasions she replaced the ball with dried bone. It took Rocky a
            month to handle half an hour of solitude. Monica could start with longer intervals a continuously leave
            Rocky at home. She and her boyfriend adjusted their working hours so they would not leave Rocky on his own
            for more than five hours. On rare occasion her mother came to keep an eye on Rocky. Rocky is now calm and
            satisfied when left home alone.
          </p>
        </Box>
      </Box>
    </Dialog>
  );
}

export function Dialog3({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} closeButton variant={{ sa: "infoBox" }}>
      <Box
        className={css({
          position: "relative",
          maxHeight: "90vh",
          px: "2rem",
          overflow: "scroll"
        })}
      >
        <img
          src={BibiBig.src}
          alt="dog"
          className={css({
            borderTopLeftRadius: "1.5rem",
            borderTopRightRadius: "1.5rem",
            position: "absolute",
            left: "0",
            top: "0",
            right: "0",
            zIndex: 0
          })}
        />
        <Box
          className={css({
            zIndex: 0,
            position: "relative",
            "& .bold": {
              color: "highEmphasis",
              fontWeight: 700
            },
            "& p": {
              mb: "16px"
            }
          })}
        >
          <Flex
            className={css({
              height: ["200px", "320px"],

              flexDirection: "column",
              justifyContent: "center"
            })}
          >
            <h2 className={css({ textAlign: "center", color: "white", mb: "16px" })}>
              Bibi o samotě pojídala <br />
              své výkaly
            </h2>
            <p className={css({ textAlign: "center", color: "rgba(255, 255, 255, 0.6)" })}>MVDr. Hana Žertová</p>
          </Flex>

          <p className={css({ mt: "24px" })}>
            <span className="bold">Rasa:</span> Francouzský buldoček
          </p>
          <p>
            <span className="bold">Věk:</span> 7 měsíců
          </p>
          <p>
            <span className="bold">Příznaky:</span> Kálení(pojídání výkalů), močení
          </p>

          <p>
            Bibi byla sedmiměsíční fenka francouzského buldočka. Žila v městském bytě se svými páníčky, kteří byli už v
            důchodovém věku a většinu času s ní bývali doma. Bibi byla moc šikovná a poslušná, naučila se spoustu triků
            a skvěle vycházela s vnoučaty. Majitelé s ní ale měli jeden problém: Jakmile zůstala sama doma, byť jen na
            deset minut, hned se vymočila a vykálela a své výkaly pak pojídala. Její samota netrvala nikdy dlouho,
            maximálně dvě hodiny.
          </p>

          <p>
            Ven chodila často, navíc před odchodem ji majitelé vždycky důkladně vyvenčili, ale nebylo to nic platné.
            Jakmile viděla, že se někdo obléká a chystá k odchodu, začala běhat po bytě, motala se pod nohama, funěla
            jako lokomotiva. Bylo těžké nechat ji za dveřmi a odejít.
          </p>
          <p>
            Naštěstí nikdy nevyla, neštěkala ani nic neničila - ale loužičky a napůl snězené hromádky svědčily o tom, že
            ji samota děsí. Fenka nejprve absolvovala veterinární vyšetření, aby se zjistilo, zda její přehnané močení a
            kálení nemá nějakou zdravotní příčinu. Byla ale po zdravotní stránce docela v pořádku.
          </p>
          <p>
            Důvodů, proč psi pojídají vlastní výkaly, může být více. Vzhledem k tomu, že tento jev je častější u fen než
            u psů, má se zato, že jde o instinktivní jednání především psích matek, které se snaží odstranit z doupěte
            všechny výrazné pachy, aby nepřilákaly predátory. Často se však vyskytuje i u štěňat odchovávaných v
            prostředí bez hraček a jakýchkoli zajímavých podnětů jako projev nudy a snahy si hrát. Někdy psi pojídají
            výkaly i ve strachu z trestu. Důvodem může být také hlad nebo nedostatek některých živin. V tomto případě
            však šlo nejspíše o tzv. přeskokové chování v důsledku silných emocí, strachu a úzkosti. Majitelé si totiž
            dodatečně uvědomili, že kdykoli je Bibi hodně rozrušená, ať příjemně nebo negativně, bere do pusy všechno,
            co najde - hračky, bačkoru, hadr, ponožku, misku - a běhá s tím po bytě.
          </p>

          <p>
            Náprava spočívala především v desenzitizačním a kontrapodmiňovacím cvičení. Bylo třeba Bibinku pomaličku
            naučit, že přípravy k odchodu neznamenají ohrožení, ale naopak jsou předzvěstí příjemných chvilek s plnicími
            hračkami, které fenka nikdy jindy neokusí, než právě při nácviku a později při krátké samotě. Protože fenka
            byla, jako většina buldočků, stále při chuti, za pár týdnů pilného cvičení bylo po problému. Majitelé
            docílili toho, že ve chvíli, kdy se začali oblékat a chystat k odchodu, Bibi usedla před kuchyňskou linku,
            kde byly nachystané naplněné hračky, a pohledem jako by je už posílala pryč. Mohli si bez starostí nakoupit
            i zajít k lékaři či do divadla, loužičky ani hromádky už nehrozily. Jen při příchodu je vítala rozradostněná
            Bibinka snahou popadnout do tlamky všechny ty úžasné hračky najednou.
          </p>
        </Box>
      </Box>
    </Dialog>
  );
}

export function Dialog4({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} closeButton variant={{ sa: "infoBox" }}>
      <Box
        className={css({
          position: "relative",
          maxHeight: "90vh",
          px: "2rem",
          overflow: "scroll"
        })}
      >
        <img
          src={RockyBig.src}
          alt="dog"
          className={css({
            borderTopLeftRadius: "1.5rem",
            borderTopRightRadius: "1.5rem",
            position: "absolute",
            left: "0",
            top: "0",
            right: "0",
            zIndex: 0
          })}
        />
        <Box
          className={css({
            zIndex: 0,
            position: "relative",
            "& .bold": {
              color: "highEmphasis",
              fontWeight: 700
            },
            "& p": {
              mb: "16px"
            }
          })}
        >
          <Flex
            className={css({
              height: ["200px", "320px"],

              flexDirection: "column",
              justifyContent: "center"
            })}
          >
            <h2 className={css({ textAlign: "center", color: "white", mb: "16px" })}>
              Rocky vyl a naříkal
              <br />
              když byl sám
            </h2>
            <p className={css({ textAlign: "center", color: "rgba(255, 255, 255, 0.6)" })}>MVDr. Hana Žertová</p>
          </Flex>

          <p className={css({ mt: "24px" })}>
            <span className="bold">Rasa:</span> Jack Russell Terriér
          </p>
          <p>
            <span className="bold">Věk:</span> 15 měsíců
          </p>
          <p>
            <span className="bold">Příznaky:</span> Kňučení, vytí, nechutenství
          </p>

          <p>
            {" "}
            Rocky je patnáctiměsíční čilý a veselý pejsek, jen je jako každý teriér trochu uštěkaný. Jeho panička Monika
            si jej přivezla, když mu bylo devět týdnů. Pilně docházela do štěněcí školičky a pak i na cvičiště. Rockyho
            bavilo hlavně aportování míčku, a tak s ním Monika začala trénovat flyball. Plány jim překazil Moničin úraz.
            Při pádu na lyžích si ošklivě zlomila nohu a léčila se téměř dva měsíce. V té době se s Rockym velice
            sblížila, byli stále spolu doma, hráli si, odpočívali. Na krátké vycházky jej bral Moničin přítel nebo
            maminka.
          </p>

          <p>
            Když se Monika zotavila, nastoupila zpátky do práce a Rocky zůstal doma sám. Nikdy dříve neměl se samotou
            problém - Monika jej zodpovědně přivykala na samotu od prvních dnů a Rocky byl doma klidný a spokojený.
            Většinu dne prospal, jen občas se rozštěkal, když slyšel zvuky z chodby. Nyní však hned po Moničině odchodu
            spustil nářek a s malými přestávkami štěkal, kňučel a vyl po celou dobu, co byla v práci. Sousedka, která
            byla doma s malým dítětem, Monice telefonovala a dělala si o pejska starost. Když se Monika vrátila, našla
            Rockyho rozčileného, udýchaného, uslintaného, s očima navrch hlavy. Vítal ji, jako by ji neviděl týden.
            Granule, voda i kousací kostičky byly nedotčené, ale hned po přivítání se Rocky vrhl do misek a všechno
            doháněl. Po procházce vyčerpaně usnul Monice pod nohama, ale stále si ji hlídal - jakmile se zvedla,
            ostražitě ji sledoval. Druhý den byl Rocky nervózní, hned jak se probudil. Od Moniky se ani nehnul, ocásek
            měl svěšený, třásl se. Monika zapnula webkameru, aby viděla, jak se bude Rocky chovat po jejím odchodu. Jen
            co odešla z domu, Rocky spustil nářek u dveří. Za chvilku se sice uložil na pohovku, ale stále se díval na
            dveře a pofňukával. Jakmile zaslechl z chodby nějaké zvuky, utíkal ke dveřím, chvilku poslouchal a zase
            začal výt a naříkat. Monika se pro něj vrátila domů, a raději jej vzala s sebou do práce. Jenže to bylo jen
            dočasné řešení. Jak ho znovu naučit být doma sám a nebát se?
          </p>
          <p>
            Nejprve bylo potřeba zařídit, aby Rocky vůbec sám nezůstal. Dopoledne chodil do práce s Monikou, odpoledne a
            večer, když bylo potřeba, mohl být s Moničinou maminkou. Druhým úkolem bylo Rockyho celkově zklidnit, aby
            nebyl ve svých projevech tak výbušný. To už bylo těžší vzhledem k jeho naturelu. Zkusili jsme upravit stravu
            - ubrat tuky a proteiny v krmivu a přidávat doplněk stravy s obsahem tryptofanu (aminokyselina, ze které
            vzniká serotonin, tzv. hormon štěstí) a vitaminů řady B, které působí blahodárně na nervový systém. Flyball,
            který je vysoce adrenalinovým sportem, jsme nahradili aktivitami zaměřenými na klidné soustředění, především
            čichovými pracemi (vyhledávání předmětů psovoda, stopa). Monika byla překvapená, jak se to Rockymu líbilo a
            jak úžasné schopnosti projevil. Dalším důležitým prvkem, který bylo třeba nacvičit, bylo uvolnění a
            uklidnění. Monika, která byla zvyklá Rockyho stále povzbuzovat a hecovat, musela najednou používat docela
            jinou řeč těla, jinou intonaci a sílu hlasu, jiné grimasy, aby se Rocky naučil soustředěně pracovat a
            uvolněně odpočívat.
          </p>

          <p>
            Současně jsem doporučila pár úprav v bytě: Rockyho rozčilovaly zvuky, které slyšel z chodby, bylo tedy na
            místě připevnit na vchodové dveře dobrou zvukovou izolaci a zabránit pejskovi v přístupu do předsíně i v
            době, kdy je s ním někdo doma. V Moničině kanceláři měl Rocky svůj pelíšek v ohrádce, aby neobtěžoval
            ostatní kolegy, a byl tam docela spokojený. Stejnou ohrádku pořídila Monika i domů do obýváku. Navíc dostal
            Rocky nové plnicí hračky - gumový Kong a plastové míčky s otvory. Když se s nimi naučil hrát, dostával je
            vždy jen na chvilku, aby mu byly vzácné a plně se soustředil na jejich vyprázdnění.
          </p>

          <p>
            Teprve teď jsme mohli začít uplatňovat metody používané k odstranění strachu ze samoty, desenzitizaci
            spojenou s kontrapodmiňováním. Při desenzitizaci je pes vystavován strachovému podnětu (samotě a všemu, co s
            ní souvisí) jen v takové míře, aby to nevyvolalo znepokojení. Kontrapodmiňování znamená postupné vytvoření
            nového, správného podmíněného reflexu na původní strachový impulz, tedy na odchod majitele. Monika cvičila
            jak v práci, tak večer a o víkendech doma. Když se Rocky po vycházce uvelebil na pelíšku, dostal naplněný
            Kong a Monika zavřela ohrádku. Vstala a zase si sedla, vstala a udělala pár kroků ke dveřím, hned se zase
            vrátila a na chvíli ohrádku otevřela, pak vzala do ruky kabelku, vyndala klíče, zase pár kroků ke dveřím a
            hned zpátky. Na Rockyho nemluvila a nevšímala si ho, ale poočku sledovala, jestli v něm její chování
            nevyvolá náznak strachu. V plnicích hračkách postupně Rocky dostával většinu své krmné dávky, doplněné o
            sušená střívka či plíce nebo kousky zeleniny, kterými byla hračka proložena. Když zůstával klidný při všech
            rituálech, které zpravidla předcházejí odchodu Moniky z bytu, mohla Monika začít skutečně odcházet. Nejprve
            na vteřinku, a pak pomaličku přidávat. Rocky měl někdy ohrádku zavřenou, jindy otevřenou, Monika střídala
            kratší a delší nepřítomnost, někdy ke Kongu přidala plnicí míček, jindy sušenou kost. Za měsíc zvládl Rocky
            půlhodinovou samotu. Monika mohla začít s delšími intervaly a postupně nechávat Rockyho doma. S přítelem si
            upravili pracovní dobu tak, aby Rocky nemusel být více než 5 hodin sám, ve výjimečných případech mu přišla
            dělat společnost Moničina maminka. Rocky je doma zase klidný a spokojený.
          </p>
        </Box>
      </Box>
    </Dialog>
  );
}
